import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/form/Button";
import Card from "components/Layout/Card";
import Profile from "components/Layout/Profile";
import Pagination from "react-bootstrap/Pagination";
import Loader from "components/Layout/Loader";
import {
  deletePost,
  fetchPost,
  setPostID,
  setRProfileID,
  showSuccess,
} from "store/slices";
import { icons } from "utils/constants";
import moment from "moment";

const DeleteRequestList = () => {
  const dispatch = useDispatch();

  const [postList, setPostList] = useState([]);
  const [totalPost, setTotalPost] = useState(0);
  const [loading, setLoading] = useState(false);
  const [restoreLoadingId, setRestoreLoadingId] = useState(null);
  const { postID } = useSelector((state) => ({
    postID: state.global.postID,
  }));

  const [paginate, setPaginate] = useState({
    offset: 0,
    limit: 9,
    total: 0,
  });

  const [activePage, setActivePage] = useState(1);
  const totalPage = Math.ceil(paginate.total / paginate.limit);
  const getPost = async (offset = 0) => {
    try {
      setLoading(true);
      const payload = {
        deleted_posts: 1,
        offset,
        limit: paginate.limit,
      };

      const res = await dispatch(fetchPost("discover", payload));
      if (res?.status === 200) {
        setPostList(res?.data?.postList || []);
        setTotalPost(res?.data?.count || 0);
        setPaginate((prev) => ({
          ...prev,
          total: res?.data?.count || 0,
          offset,
        }));
      }
    } catch (error) {
      console.error("Error fetching deleted posts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPost();
  }, [postID]);



  const handlePagination = (newOffset) => {
    setActivePage(newOffset / paginate.limit + 1);
    getPost(newOffset);
  };

  // Restore Post
  const handleRestore = async (postId) => {
    setRestoreLoadingId(postId);
    try {
      const payload = { post_id: postId, key: "restore" };
      const response = await dispatch(deletePost(payload));
      if (response?.status === 200) {
        setPostList((prev) => prev.filter((item) => item.id !== postId));
        dispatch(showSuccess(response.message));
        setTotalPost((prev) => prev - 1);
      }
    } catch (err) {
      console.error("Restore failed:", err);
    } finally {
      setRestoreLoadingId(null);
    }
  };

  const handleViewPost = (postId) => {
    dispatch(setPostID(postId));
  };


  if (loading)
    return (
      <Card className="center-flex cpt-50 cpb-50">
        <Loader size="md" />
      </Card>
    );


  return (
    <div className="cmb-20">
      <div className="text-16-500-20 color-title-navy">
        Deleted Posts ({totalPost})
      </div>

      <div className="row g-3 cmt-7">
        {postList?.length === 0 ? (
          <div className="text-center text-16-500 color-davys-gray">
            No deleted posts found.
          </div>
        ) : (
          postList.map((post) => {
            const {
              id,
              title,
              sub_category_name,
              category_name,
              user_details,
              author_details,
              created_date,
              deleted_by,
              delete_reason,
              deleted_at
            } = post;

            const isResearchProfile = ["2", "5"].includes(
              user_details?.user_type
            );
            const isAuthorResearchProfile = ["2", "5"].includes(
              author_details?.user_type
            );

            return (
              <div key={id} className="col-12 col-md-6 col-lg-4">
                <Card
                  className="cp-20 border d-flex flex-column justify-content-between"
                  style={{
                    minHeight: "390px",

                  }}
                >
                  <div
                    className="text-14-400 cmb-14 color-new-car"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {title || ""}
                  </div>

                  <div className="d-flex align-items-center justify-content-between cmb-16">
                    <Button
                      text={sub_category_name || category_name || "N/A"}
                      btnStyle="primary-light"
                      className="h-auto text-14-400"
                      isSquare
                    />
                  </div>

                  <div className="d-flex align-items-center left-block cmb-16">
                    <Profile
                      isRounded
                      isS3UserURL
                      text={user_details?.name}
                      size="s-40"
                      url={user_details?.profile_photo}
                    />
                    <div className="user-details-block ms-3">
                      <div
                        className={`text-14-400-18 cmb-6 ${isResearchProfile
                          ? "color-new-car pointer hover-effect"
                          : "color-raisin-black"
                          }`}
                        onClick={() =>
                          isResearchProfile &&
                          dispatch(setRProfileID(user_details?.id))
                        }
                      >
                        {user_details?.name || ""}
                      </div>
                      <div className="text-12-400-15 color-6866">
                        {`${user_details?.state || ""} ${user_details?.country || ""
                          }`}
                      </div>
                    </div>
                  </div>

                  {author_details?.name && (
                    <div className="d-flex align-items-center gap-3 cmb-10">
                      <div className="text-14-400-18 color-1717">Author:</div>
                      <div
                        className={`text-14-300-18 ${isAuthorResearchProfile
                          ? "color-new-car pointer hover-effect"
                          : ""
                          }`}
                      >
                        {author_details?.name}
                      </div>
                    </div>
                  )}

                  <div className="text-14-300-18 color-black-olive cmb-16">
                    <span className="me-2">
                      <img src={icons.calendarEvent} alt="calendar" />
                    </span>
                    {moment(created_date, "DD-MM-YYYY HH:mm:ss").format(
                      "DD-MMM-YYYY"
                    ) || "N/A"}
                  </div>

                  <div className="text-14-300-18 color-black-olive border-top pt-2 mt-auto d-flex flex-column gap-2">
                    <div>Deleted By: {deleted_by || "-"}</div>
                    <div className="text-truncate" title={delete_reason}>
                      Reason: {delete_reason || "-"}
                    </div>
                    <div>Deleted At: {moment(deleted_at, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY") || '-'}</div>
                  </div>

                  <div className="d-flex flex-row gap-2 cmt-15">
                    <Button
                      text="Restore"
                      btnStyle="primary-dark"
                      className="h-35 cps-20 cpe-20"
                      onClick={() => handleRestore(id)}
                      btnLoading={restoreLoadingId === id}
                      disabled={restoreLoadingId === id}
                    />
                    <Button
                      text="View Post"
                      icon={
                        <span className="cpe-5">
                          <img src={icons.DarkBlueEye} alt="view" />
                        </span>
                      }
                      btnStyle="primary-light-outline"
                      className="h-35 cps-20 cpe-20"
                      onClick={() => handleViewPost(id)}
                    />
                  </div>
                </Card>
              </div>
            );
          })
        )}
      </div>

      {totalPage > 1 && (
        <div className="d-flex align-items-center justify-content-between flex-wrap footer-block">
          <div className="d-flex gap-4 cmt-30 cpb-30">
            <Button
              icon={<i className="bi bi-chevron-left me-1" />}
              text="Previous"
              btnStyle={activePage === 1 ? "primary-gray" : "primary-dark"}
              className="cps-20 cpe-20"
              onClick={() => {
                if (activePage !== 1) {
                  handlePagination(paginate?.offset - paginate?.limit);
                }
              }}
              isRounded
            />
            <Button
              rightIcon={<i className="bi bi-chevron-right ms-2" />}
              text="Next"
              btnStyle={
                activePage === totalPage ? "primary-gray" : "primary-dark"
              }
              className="cps-40 cpe-30"
              onClick={() => {
                if (activePage !== totalPage) {
                  handlePagination(paginate?.offset + paginate?.limit);
                }
              }}
              isRounded
            />
          </div>

          <div className="d-flex align-items-center">
            <Pagination className="d-flex align-items-center unset-m">
              <div className="text-16-400 color-davys-gray me-1">Page</div>
              <Pagination.Item disabled>{activePage}</Pagination.Item>
              <div className="text-16-400 color-davys-gray ms-1 me-2">of</div>
              <Pagination.Item disabled>{totalPage}</Pagination.Item>
            </Pagination>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteRequestList;



// import React from 'react';
// import { useDispatch } from 'react-redux';
// import Button from 'components/form/Button';
// import Card from 'components/Layout/Card';
// import Profile from 'components/Layout/Profile';
// import { setPostID, setRProfileID } from 'store/slices';
// import { icons } from 'utils/constants';
// import { titleCaseString } from 'utils/helpers';

// const DeleteRequestList = () => {
//   const dispatch = useDispatch();

//   const reportData = [
//     {
//       id: 1,
//       title: "How Faculty Describe Their Strengths and Challenges in University-Community",
//       user_details: { name: "John Doe", user_type: "2", profile_photo: "", state: "California", country: "USA", userID: "user-1" },
//       sub_category_name: "Research",
//       category_name: "Education",
//       author_details: { name: "Jane Smith", user_type: "2" },
//       co_authors: [{ name: "Alice" }, { name: "Bob" }],
//       isAnyCoAuthor: true,
//       created_date: "2024-07-26",
//     },
//     {
//       id: 2,
//       title: "How Faculty Describe Their Strengths and Challenges in University-Community",
//       user_details: { name: "John Doe", user_type: "2", profile_photo: "", state: "California", country: "USA", userID: "user-1" },
//       sub_category_name: "Research",
//       category_name: "Education",
//       author_details: { name: "Jane Smith", user_type: "2" },
//       co_authors: [{ name: "Alice" }, { name: "Bob" }],
//       isAnyCoAuthor: true,
//       created_date: "2024-07-26",
//     },
//   ];

//   const handleRemovePost = (postId) => {
//     console.log('Remove post:', postId);
//   };

//   const handleViewPost = (postId) => {
//     // console.log('View post:', postId);
//     dispatch(setPostID(postId));
//   };

//   return (
//     <div className="cmb-20">
//       <div className="row g-3">
//         {reportData.map((post) => {
//           const {
//             id,
//             title,
//             sub_category_name,
//             category_name,
//             user_details,
//             author_details,
//             co_authors,
//             isAnyCoAuthor,
//             created_date,
//           } = post;

//           const isReasearchProfile = ['2', '5'].includes(user_details?.user_type);
//           const isAuthorReasearchProfile = ['2', '5'].includes(author_details?.user_type);

//           return (
//             <div key={id} className="col-12 col-md-6 col-lg-4">
//               <Card className="cp-20 border" style={{ minHeight: '304px' }}>
//                 {/* Post Title */}
//                 <div
//                   className="text-14-400 cmb-14 color-new-car"
//                   style={{
//                     display: '-webkit-box',
//                     WebkitLineClamp: 2,
//                     WebkitBoxOrient: 'vertical',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                   }}
//                 >
//                   {title}
//                 </div>

//                 {/* Category */}
//                 <div className="d-flex align-items-center justify-content-between cmb-16">
//                   <Button
//                     text={sub_category_name || category_name}
//                     btnStyle="primary-light"
//                     className="h-auto text-14-400"
//                     isSquare
//                   />
//                 </div>

//                 {/* Author/Profile Info */}
//                 <div className="d-flex align-items-center left-block cmb-16">
//                   <Profile
//                     isRounded
//                     isS3UserURL
//                     text={user_details?.name}
//                     size="s-40"
//                     url={user_details?.profile_photo}
//                   />
//                   <div className="user-details-block ms-3">
//                     <div
//                       className={`text-14-400-18 cmb-6 ${isReasearchProfile ? 'color-new-car pointer hover-effect' : 'color-raisin-black'}`}
//                       onClick={() => isReasearchProfile && dispatch(setRProfileID(user_details?.userID))}
//                     >
//                       {user_details?.name}
//                     </div>
//                     <div className="text-12-400-15 color-6866">
//                       {`${user_details?.state || ''} ${user_details?.country || ''}`}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Author Name */}
//                 {author_details?.name && (
//                   <div className="d-flex align-items-center gap-3 cmb-16">
//                     <div className="text-14-400-18 color-1717">Author:</div>
//                     <div className={`text-14-300-18 ${isAuthorReasearchProfile ? 'color-new-car pointer hover-effect' : ''}`}>
//                       {author_details.name}
//                     </div>
//                   </div>
//                 )}

//                 {/* Co-Authors */}
//                 {co_authors?.length > 0 && isAnyCoAuthor && (
//                   <div className="d-flex align-items-center gap-3 cmb-16">
//                     <div className="text-14-400-18 color-1717">Co Author:</div>
//                     {co_authors.map((coAuthor, i) => (
//                       <div key={i} className={`text-14-300-18 d-flex ${isReasearchProfile ? 'color-new-car pointer hover-effect' : ''}`}>
//                         {titleCaseString(coAuthor.name)}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Date */}
//                 <div className='text-14-300-18 color-black-olive cmb-16'>
//                   <span className='me-2'><img src={icons.calendarEvent} alt="calendar" /></span>
//                   {created_date}
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="d-flex flex-row gap-2">
//                   <Button
//                     text="Delete Post"
//                     btnStyle="primary-dark"
//                     className="h-35 cps-20 cpe-20"
//                     onClick={() => handleRemovePost(id)}
//                   />
//                   <Button
//                     text="View Post"
//                     icon={<span className="cpe-5"><img src={icons.DarkBlueEye} loading="lazy" alt="view" /></span>}
//                     btnStyle="primary-light-outline"
//                     className="h-35 cps-20 cpe-20"
//                     onClick={() => handleViewPost(id)}
//                   />
//                 </div>
//               </Card>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default DeleteRequestList;
